import type { FaireProductEntity } from "../../entity_types/product";

export const p_szr2yjjm3w: FaireProductEntity = {
  token: "p_szr2yjjm3w",
  type: "product",
  name: "JESUS LOVES ME Letter Bracelet",
  brandToken: "b_k5p875q9mb",
  brandName: "Holy Pals",
  imageUrl:
    "https://cdn.faire.com/fastly/8531749226494636a7e8a8a0f48c104d357999394d55910859d3bd1c2b2ef358.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8420d8ddfd1fefa67c01e04d258ab7d924b37b9c4022a4d0f3236dfe3dbb7af4.jpeg",
    "https://cdn.faire.com/fastly/802b236b96af8ee50b174528a1e801b2e4d8af41169bc7fedb905583dd9ceaf0.jpeg",
    "https://cdn.faire.com/fastly/ae839b7b0e6890c1e9bc93f26d04165b20f89dc62767ff08238682517b46af48.jpeg",
  ],
  priceDollars: 9.8,
  description:
    "JESUS LOVES ME Letter Bracelet\nDiameters: \n XS - 15cm\n S - 17cm\n M - 19cm\n",
  tags: [],
  msrpDollars: 14,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:52.274Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
